/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from '@/0-dashboard/menu-items'
import shiftsAndGigs from '@/1-shifts-&-gigs/menu-items'
import hr from '@/2-hr/menu-items'
import payAndBilling from '@/3-pay-&-billing/menu-items'

const vertical = [
  ...dashboard.menuItems, 
  shiftsAndGigs.header, ...shiftsAndGigs.menuItems, 
  hr.header, ...hr.menuItems,
  payAndBilling.header, ...payAndBilling.menuItems
]

const horizontal = [ // TODO use map
  ...dashboard.menuItems,
  {...shiftsAndGigs.header, children: shiftsAndGigs.menuItems},
  {...hr.header, children: hr.menuItems},
  {...payAndBilling.header, children: payAndBilling.menuItems},
]
export default {vertical, horizontal}